import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useStoreByName } from '@web/hooks/use-stores.hooks';
import { VOICE_LEVEL } from '@web/utils/voice-level';
import type { VoiceLevelController } from '../../../stores/controllers/voice-level.controller';

/**
 * Five small LEDs beside the microphone light: green while the voice is in
 * range, amber when it is quiet, red when it clips. A "speak up" bubble shows
 * above it once per reading after three seconds of quiet. Behind the
 * isVoiceLevelMeterEnabled switch; renders nothing while not listening.
 */
const VoiceLevelMeter: React.FC = observer(() => {
  const speechRecognitionStore = useStoreByName('speechRecognitionStore') as any;
  const { t } = useTranslation();
  const voiceLevel: VoiceLevelController | undefined = speechRecognitionStore.voiceLevel;

  if (!voiceLevel?.meterEnabled || !speechRecognitionStore.isListening) return null;

  const { segments, state, speakUpVisible } = voiceLevel;

  return (
    <div className={`voice-meter voice-meter--${state}`}>
      <div
        className="voice-meter__leds"
        role="meter"
        aria-label={t('voiceLevelMeterLabel')}
        aria-valuemin={0}
        aria-valuemax={VOICE_LEVEL.METER_STEPS_DBFS.length}
        aria-valuenow={segments}
      >
        {VOICE_LEVEL.METER_STEPS_DBFS.map((_, index) => (
          <span key={index} className={`voice-meter__led${index < segments ? ' voice-meter__led--lit' : ''}`} />
        ))}
      </div>
      {speakUpVisible && (
        <div className="voice-meter__bubble" role="status">
          {t('speakUp')}
        </div>
      )}
    </div>
  );
});

export default VoiceLevelMeter;
